import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Link,
  Checkbox,
  FormControlLabel,
  Collapse,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
  RadioGroup, Radio
} from "@mui/material";
import {
  obtenerDatosHotel,
  leerParametroURL,
  enctriptoParaAdmintour,
} from "../../services/motorService";
import RoomTypeRatePlanContext from "../contexts/RoomTypeRatePlanContext";
import webpay from "./webpay1.png";
import compraaqui from "./compraaqui.png";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import useSession from "../../services/session";
import CheckoutContext from "../contexts/CheckoutContext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme, useMediaQuery } from "@mui/material";

const CUSTOM_PAYMENT_OPTIONS = {
  "30": [
    { type: "subheader", label: "Red de cobranza" },
    {
      type: "option",
      code: "1",
      label: "Red Pagos",
      group: "RED_COBRANZA",
    },
    { type: "subheader", label: "Tarjetas / Bancos" },
    {
      type: "option",
      code: "157",
      label: "HSBC",
      group: "TARJETA_BANCO",
    },
  ],
  "31": [
    { type: "subheader", label: "Red de cobranza" },
    {
      type: "option",
      code: "1",
      label: "Red Pagos",
      group: "RED_COBRANZA",
    },
    { type: "subheader", label: "Tarjetas / Bancos" },
    {
      type: "option",
      code: "110",
      label: "BANDES",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "153",
      label: "BBVA",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "001",
      label: "BROU",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "216",
      label: "HERITAGE",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "157",
      label: "HSBC",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "113",
      label: "ITAÚ",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "137",
      label: "SANTANDER",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "1108",
      label: "OCA",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "1119",
      label: "Prex",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "1110",
      label: "Visa",
      group: "TARJETA_BANCO",
    },
    {
      type: "option",
      code: "1109",
      label: "PassCard",
      group: "TARJETA_BANCO",
    },
  ],
};

const Payment = ({
  aceptaTerminosTransferencia,
  setAceptaTerminosTransferencia,
  onBeforeWebpay,
}) => {
  const [tarjetaEnGarantia, setTarjetaEnGarantia] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hotcodParam = params.get("hotcod");
  const hotCod = hotcodParam ?? Cookies.get("hotCod") ?? null;
  const valorT = params.get("t");

  const [datosHotel, setDatosHotel] = useState({});
  const navigate = useNavigate();
  const [transactionLoading, setTransactionData] = useState(false);
  const { cartItems } = useContext(RoomTypeRatePlanContext);
  const { formValues, setFormValues } = useContext(CheckoutContext);
  const session = useSession();
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [mostrarNormas, setMostrarNormas] = useState(false);
  const [mostrarDatosPersonales, setMostrarDatosPersonales] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [creating, setCreating] = useState(false);
  const [tipoPagoGarantiaB, setTipoPagoGarantiaB] = useState(""); //banco estado

  const customPaymentOptions = CUSTOM_PAYMENT_OPTIONS[String(hotCod)] || null;
  const usaMetodoPagoPersonalizado = Boolean(customPaymentOptions);

  const paymentOptionsOnly = (customPaymentOptions || []).filter(
    (item) => item.type === "option"
  );

  const aceptaTransferencia =
    datosHotel.transferencia === "S" ||
    Boolean(datosHotel.Banco || datosHotel.CuentaBanco || datosHotel.aliascuenta);

  const paisHotelNormalizado = String(
    datosHotel?.MotorHotPais ||
    datosHotel?.HotelPaisCodigo ||
    datosHotel?.Pais ||
    datosHotel?.PaisCodigo ||
    datosHotel?.MotorHotPaisNombre ||
    ""
  )
    .trim()
    .toUpperCase();

  const esHotelChile =
    paisHotelNormalizado === "CHILE" ||
    paisHotelNormalizado === "CL" ||
    paisHotelNormalizado === "56";

  useEffect(() => {
    const getData = async () => {
      try {
        const data = await obtenerDatosHotel(hotCod);
        setDatosHotel(data);
        setTarjetaEnGarantia(data.MotorHotSolTarjeta);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    };
    getData();
  }, [hotCod]);

  /*const totalImporte = cartItems
    ? cartItems.reduce(
        (total, item) => total + parseFloat(item.CarritoItemTotal || 0),
        0
      )
    : 0;
*/
  const totalImporte = Array.isArray(cartItems)
    ? cartItems.reduce(
      (total, item) => total + parseFloat(item.CarritoItemTotal || 0),
      0
    )
    : 0;
  const handlePaymentMethodChange = (event) => {
    const selectedCode = event.target.value;
    const selectedOption = paymentOptionsOnly.find(
      (opt) => opt.code === selectedCode
    );

    setFormValues((prev) => ({
      ...prev,
      paymentMethodCode: selectedCode,
      paymentMethodLabel: selectedOption?.label || "",
      paymentMethodGroup: selectedOption?.group || "",
    }));
  };

  const renderCustomPaymentSelector = () => {
    if (!usaMetodoPagoPersonalizado) return null;

    return (
      <Box sx={{ mb: 3 }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>Método de Pago</strong>
        </Typography>

        <FormControl fullWidth size="small">
          <InputLabel id="payment-method-select-label">
            Seleccione una opción
          </InputLabel>
          <Select
            labelId="payment-method-select-label"
            value={formValues?.paymentMethodCode || ""}
            label="Seleccione una opción"
            onChange={handlePaymentMethodChange}
          >
            {customPaymentOptions.map((item, index) =>
              item.type === "subheader" ? (
                <ListSubheader
                  key={`subheader-${index}`}
                  sx={{
                    fontWeight: 700,
                    color: "text.primary",
                    lineHeight: 1.8,
                    backgroundColor: "#fff",
                  }}
                >
                  {item.label}
                </ListSubheader>
              ) : (
                <MenuItem key={item.code} value={item.code}>
                  {item.label}
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
      </Box>
    );
  };

  const handleCreateTransaction = async () => {
    if (creating) return;

    setCreating(true);
    try {
      localStorage.setItem("checkoutForm", JSON.stringify(formValues));
      localStorage.setItem("checkoutStep", JSON.stringify(1));

      const reservaMotorNro =
        typeof onBeforeWebpay === "function" ? await onBeforeWebpay() : null;

      if (!reservaMotorNro) {
        setCreating(false);
        return;
      }

      const urlBackend = await leerParametroURL("PAGO_GX18_MOTOR");
      const hotel = datosHotel.MotorHotAdmintour;
      const laSesion = session;
      const importe = totalImporte;
      const hotelEnElMotor = hotCod;

      const datoAEncriptar =
        hotel +
        "|" +
        laSesion +
        "|" +
        importe +
        "|" +
        hotelEnElMotor +
        "|" +
        reservaMotorNro;

      const encriptado = await enctriptoParaAdmintour(datoAEncriptar);

      const urlCompleta =
        urlBackend.UrlParametro.trim() +
        "?Encrypt64=" +
        encriptado.DatosEncriptado;

      window.location.href = urlCompleta;
    } catch (e) {
      console.error("No se pudo iniciar Webpay:", e);
      setCreating(false);
    }
  };

  //banco estado
  const handleCreateTransactionCompraAqui = async () => {
    if (creating) return;

    setCreating(true);

    try {
      localStorage.setItem("checkoutForm", JSON.stringify(formValues));
      localStorage.setItem("checkoutStep", JSON.stringify(1));
      localStorage.setItem("paymentType", "COMPRA_AQUI");

      const reservaMotorNro =
        typeof onBeforeWebpay === "function"
          ? await onBeforeWebpay()
          : null;

      if (!reservaMotorNro) {
        setCreating(false);
        return;
      }

      const urlBackend = await leerParametroURL("COMPRAAQUI_INICIO");

      const hotel = datosHotel.MotorHotAdmintour;
      const laSesion = session;

      // SOLO CAMBIA ESTO
      const importe = totalImporte * 0.5;

      const hotelEnElMotor = hotCod;

      const datosEnc = valorT;

      const datoAEncriptar =
        hotel +
        "|" +
        laSesion +
        "|" +
        importe +
        "|" +
        hotelEnElMotor +
        "|" +
        reservaMotorNro +
        "|" +
        datosEnc
        ;

      const encriptado = await enctriptoParaAdmintour(
        datoAEncriptar
      );

      const urlCompleta =
        urlBackend.UrlParametro.trim() +
        "?Encrypt64=" +
        encriptado.DatosEncriptado;

      window.location.href = urlCompleta;
    } catch (e) {
      console.error("No se pudo iniciar Compra Aqui:", e);
      setCreating(false);
    }
  };


  if (loading) {
    return <p>Cargando...</p>;
  }

  return (
    <>
      <Box>
        {usaMetodoPagoPersonalizado ? (
          <Box>
            {renderCustomPaymentSelector()}

            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label="Acepto los términos y políticas de reserva del hotel"
            />

            {esHotelChile && (
              <>
                <Box
                  onClick={() =>
                    setMostrarDatosPersonales(!mostrarDatosPersonales)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "fit-content",
                    mt: 1,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ mr: 1 }}>
                    Ver política de protección de datos personales
                  </Typography>
                  {mostrarDatosPersonales ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </Box>

                <Collapse in={mostrarDatosPersonales}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: 2,
                      borderRadius: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                      mb: 3,
                    }}
                  >
                    <Typography variant="body2">
                      {datosHotel.MotorHotDatosPersonales}
                    </Typography>
                  </Box>
                </Collapse>
              </>
            )}

            <Box
              onClick={() => setMostrarNormas(!mostrarNormas)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                width: "fit-content",
                mb: 3,
              }}
            >
              <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                Ver normas del hotel
              </Typography>
              {mostrarNormas ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarNormas}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.Condiciones}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        ) : tarjetaEnGarantia === "S" ? (
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminos}
                  onChange={(e) => setAceptaTerminos(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2">
                  Acepto los{" "}
                  <Link
                    component="button"
                    variant="body2"
                    underline="always"
                    onClick={() => setOpenDialog(true)}
                  >
                    términos y políticas de reserva del hotel
                  </Link>
                </Typography>
              }
            />

            <Box
              onClick={() => setMostrarDatosPersonales(!mostrarDatosPersonales)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mt: 1,
                width: "fit-content",
              }}
            >
              <Typography sx={{ mr: 1 }}>
                Ver política de protección de datos personales
              </Typography>
              {mostrarDatosPersonales ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarDatosPersonales}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.MotorHotDatosPersonales}
                </Typography>
              </Box>
            </Collapse>

            <Box
              sx={{
                mb: 3,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={handleCreateTransaction}
                disabled={!aceptaTerminos || transactionLoading}
                sx={{
                  backgroundColor: "white",
                  borderRadius: 2,
                  padding: 1.5,
                  boxShadow: 3,
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "scale(1.03)",
                    boxShadow: 6,
                    backgroundColor: "white",
                  },
                  opacity: aceptaTerminos ? 1 : 0.5,
                }}
              >
                <Box
                  component="img"
                  src={webpay}
                  alt="Pagar con Webpay"
                  sx={{
                    width: { xs: "100%", sm: "260px" },
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              </Button>
            </Box>
          </Box>
        ) : tarjetaEnGarantia === "B" ? (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Seleccione el método de pago</strong>
            </Typography>

            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 2,
                mb: 3,
                backgroundColor: "#fafafa",
              }}
            >
              <FormControl fullWidth>
                <RadioGroup
                  value={tipoPagoGarantiaB}
                  onChange={(e) => {
                    setTipoPagoGarantiaB(e.target.value);

                    setAceptaTerminosTransferencia(false);

                    setFormValues({
                      ...formValues,
                      paymentType: e.target.value,
                    });
                  }}
                >
                  <FormControlLabel
                    value="COMPRA_AQUI"
                    control={<Radio />}
                    label="Compra Aquí (50% de la reserva)"
                  />

                  <FormControlLabel
                    value="RECINTO"
                    control={<Radio />}
                    label="Pago en recinto"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label={
                <Typography variant="body2">
                  Acepto los{" "}
                  <Link
                    component="button"
                    variant="body2"
                    underline="always"
                    onClick={() => setOpenDialog(true)}
                  >
                    términos y políticas de reserva del hotel
                  </Link>
                </Typography>
              }
            />

            <Box
              onClick={() => setMostrarDatosPersonales(!mostrarDatosPersonales)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mt: 1,
                width: "fit-content",
              }}
            >
              <Typography sx={{ mr: 1 }}>
                Ver política de protección de datos personales
              </Typography>
              {mostrarDatosPersonales ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarDatosPersonales}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.MotorHotDatosPersonales}
                </Typography>
              </Box>
            </Collapse>

            {tipoPagoGarantiaB === "COMPRA_AQUI" && (
              <Box
                sx={{
                  mb: 3,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  onClick={handleCreateTransactionCompraAqui}
                  disabled={!aceptaTerminosTransferencia || transactionLoading}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: 2,
                    padding: 1.5,
                    boxShadow: 3,
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    "&:hover": {
                      transform: "scale(1.03)",
                      boxShadow: 6,
                      backgroundColor: "white",
                    },
                    opacity: aceptaTerminosTransferencia ? 1 : 0.5,
                  }}
                >
                  <Box
                    component="img"
                    src={compraaqui}
                    alt="Pagar con Compra Aquí"
                    sx={{
                      width: { xs: "100%", sm: "260px" },
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </Button>
              </Box>
            )}
          </Box>
        ) : aceptaTransferencia ? (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>El medio de pago es Transferencia Bancaria</strong>
            </Typography>

            <Typography variant="body1" sx={{ mt: 2 }}>
              <strong>Datos para la transferencia:</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Banco:</strong> {datosHotel.Banco}
            </Typography>
            <Typography variant="body2">
              <strong>Número de cuenta:</strong> {datosHotel.CuentaBanco}
            </Typography>
            <Typography variant="body2">
              <strong>Alias:</strong> {datosHotel.aliascuenta}
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
              <strong>Contacto para enviar comprobante:</strong>{" "}
              {datosHotel.Contacto}
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label="Acepto los términos y políticas de reserva del hotel"
            />

            {esHotelChile && (
              <>
                <Box
                  onClick={() =>
                    setMostrarDatosPersonales(!mostrarDatosPersonales)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "fit-content",
                    mt: 1,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ mr: 1 }}>
                    Ver política de protección de datos personales
                  </Typography>
                  {mostrarDatosPersonales ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </Box>

                <Collapse in={mostrarDatosPersonales}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: 2,
                      borderRadius: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                      mb: 3,
                    }}
                  >
                    <Typography variant="body2">
                      {datosHotel.MotorHotDatosPersonales}
                    </Typography>
                  </Box>
                </Collapse>
              </>
            )}

            <Box
              onClick={() => setMostrarNormas(!mostrarNormas)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                width: "fit-content",
                mb: 3,
              }}
            >
              <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                Ver normas del hotel
              </Typography>
              {mostrarNormas ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarNormas}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.Condiciones}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        ) : (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>
                Este hotel no requiere un pago anticipado para confirmar la
                reserva.
              </strong>
            </Typography>

            <Typography variant="body2" sx={{ mb: 3 }}>
              El pago de su estadía se realizará directamente en el
              establecimiento, según las políticas del hotel.
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label="Acepto los términos y políticas de reserva del hotel"
            />

            {esHotelChile && (
              <>
                <Box
                  onClick={() =>
                    setMostrarDatosPersonales(!mostrarDatosPersonales)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "fit-content",
                    mt: 1,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ mr: 1 }}>
                    Ver política de protección de datos personales
                  </Typography>
                  {mostrarDatosPersonales ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </Box>

                <Collapse in={mostrarDatosPersonales}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: 2,
                      borderRadius: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                      mb: 3,
                    }}
                  >
                    <Typography variant="body2">
                      {datosHotel.MotorHotDatosPersonales}
                    </Typography>
                  </Box>
                </Collapse>
              </>
            )}

            <Box
              onClick={() => setMostrarNormas(!mostrarNormas)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                width: "fit-content",
                mb: 3,
              }}
            >
              <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                Ver normas del hotel
              </Typography>
              {mostrarNormas ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarNormas}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.Condiciones}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        )}
      </Box>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={fullScreen}
      >
        <DialogTitle sx={{ m: 0, p: 2, position: "relative" }}>
          Términos y políticas de reserva del hotel
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialog(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {datosHotel.Condiciones || "No se han definido condiciones."}
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Payment;